export interface IConfig {
  appKey: string;
  apiUrl?: string;
  baseUrl?: string;
}

export interface Customizations {
  sheetBackgroundHexColor?: string;
  sheetCornerBorderRadius?: string;
  loadingAnimation?: string;
}
